import axios from '@/libs/api.request'

// 获取车辆列表
export const CarList = (data) => {
  return axios.request({
    url: 'car/list',
    data: data,
    method: 'post',
  })
}
// 获取车辆详情
export const CarDetail = (data) => {
  return axios.request({
    url: 'car/detail',
    data: data,
    method: 'post',
  })
}
// 添加车辆
export const CarAdd = (data) => {
  return axios.request({
    url: 'car/add',
    data: data,
    method: 'post',
  })
}
// 编辑车辆
export const CarEdit = (data) => {
  return axios.request({
    url: 'car/edit',
    data: data,
    method: 'post',
  })
}
// 删除车辆
export const CarDel = (data) => {
  return axios.request({
    url: 'car/del',
    data: data,
    method: 'delete',
  })
}
// 测试连接 CarTryConnect
export const CarTryConnect = (data) => {
  return axios.request({
    url: 'mqtt/publish',
    data: data,
    method: 'post',
  })
}

// 获取车辆实时状态
export const getCarRealTimeStatus = (data) => {
  return axios.request({
    url: 'car/realtime/status',
    data: data,
    method: 'post',
  })
}

// 获取车辆实时位置
export const getCarRealTimeLocation = (data) => {
  return axios.request({
    url: 'car/realtime/location',
    data: data,
    method: 'post',
  })
}

// 获取车辆实时电量
export const getCarRealTimeBattery = (data) => {
  return axios.request({
    url: 'car/realtime/battery',
    data: data,
    method: 'post',
  })
}

// 获取所有车辆实时状态（用于实时监控页面）
export const getAllCarsRealTimeStatus = (data) => {
  return axios.request({
    url: 'car/realtime/all',
    data: data,
    method: 'post',
  })
}